/**
 * useAuth - Hook pour accéder au store d'authentification
 *
 * Utilise le store SolidJS pour un état réactif partagé
 * Tous les composants voient les mêmes données en temps réel
 */

import { authStore, clearUser, fetchUser, refreshUser, setUser } from '~/stores/authStore';

export const useAuth = () => {
  return {
    // State réactif (du store)
    user: () => authStore.user,
    isAuthLoading: () => authStore.isLoading,

    // Computed
    isAuthenticated: () => !!authStore.user,

    // Actions
    setUser,
    clearUser,
    fetchUser,
    refreshUser, // Pour forcer un reload après modification profile
  };
};
